module.exports = {
  lang: "English",
  webwallet_mobile_app: "APP",
  webwallet_your: "Your EVM Wallet",
  webwallet_wallet: "Wallet",
  webwallet_home_des: "Send, Request and Swap EVM blockchain tokens directly from your Blockchain Wallet",
  webwallet_login: "Login via Browser Extension",
  webwallet_copy_address: "Copy Address",
  webwallet_qr_code: "QR Code",
  webwallet_estimated_value: "Estimated Value",
  webwallet_total: "Total",
  webwallet_refresh: "Refresh",
  webwallet_logout: "Logout",
  webwallet_transactions: "Transactions",
  webwallet_erc20_transactions: "Erc20 Token Txns",
  webwallet_to_address: "To Address",
  webwallet_to_address_pl: "Recipient Address",
  webwallet_cheap: "Cheap",
  webwallet_fast: "Fast",
  webwallet_simple: "Simple",
  webwallet_advanced: "Advanced",
  webwallet_memo_pl: "Maximum 30 characters (optional)",
  webwallet_fee: "Fee",
  webwallet_txHash: "TxHash",
  webwallet_type: "Type",
  webwallet_value: "Value",
  webwallet_status: "Status",
  webwallet_block_height: "Block Height",
  webwallet_tx_time: "Tx Time",
  transaction_information: "Transaction Information",
  webwallet_refresh_balance: "Refresh Balance",
  available: "Available",
  delegate: "Delegated",
  undelegate: "Undelegating",
  transfer: "Transfer",
  transfer_amount: "Transfer Amount",
  memo: "Memo",
  noTransaction: "No transaction",
  noMathExtension: "Please connect Math Wallet first",
  from: "From",
  to: "To",
  transfer_account_null: "Please enter receive address",
  transfer_amount_null: "Please set transfer amount",
  copy_success: "Copied",
  copy_fail: "Please copy manually",
  transfer_success: "Transferred",
  transfer_fail: "Transfer failed",
  transfer_amount_min: "The transfer amount cannot be lower than ",
  back_transactions: "Back to Transaction Record",
  gas_limit: "Gas Limit",
  gas_used: "Gas Used",
  gas_price: "Gas Price",
  mathExtensionLock: "Please unlock your Math Wallet",
  contract: "Contract",
  TRC20_transfer: "TRC20 Transfers",
  check_account: "The current account is not the account selected by extension",
  gas_price_min: "Gas Price cannot be lower than 1Gwei",
  gas_limit_min: "Gas Limit cannot be lower than ",
  prompt: "Prompt",
  input_data: "Input Data",
  transfer_input: "Please enter hexadecimal data (optional)",
  locked: "Locked",
  submit_success: "Submit success",
  gas_limit_null: "Gas Limit is null",
  gas_Price_null: "Gas Price is null",
  webwallet_amount_notenough: "Have no enough available balance",
  node_not_available: "Current node is not available",
  webwallet_extrinsicID: "Extrinsic ID",
  webwallet_module: "Module",
  webwallet_signature: "Signature",
  webwallet_address: "Address",
  webwallet_transfers: "Transfers",
  noTransfer: "No transfer",
  Confirm: "Confirm",
  confirmed: "Confirmed",
  unconfirmed: "Unconfirmed",
  confirmations: "Confirmations",
  transferring: "Signing...",
  transfer_same_account: "Cannot transfer tokens to the same account",
  ledger_login: "Login via Ledger",
  add: "Add",
  receive_tips: "This address can only be used to receive %w. Do not send other tokens to this address.",
  receive: "Receive",
  noAdded: "No tokens to add",
  token_add_successful: "Successfully",
  token_add_fail: "Failed",
  switch_to: "Please switch the extension to %w",
  please_create_account: "Please create your account",
  webwallet_to_valid_address: "Please enter valid recipient address",
  ledger_lock: "Please unlock your Ledger Wallet",
  blockchain_explorer: "Blockchain Explorer",
  add_custom_token: "Add Custom Token",
  token_address: "Address",
  token_decimals: "Decimals",
  token_symbol: "Symbol",
  cancel_btn: "Cancel",
  invalid_address: "Invalid Address",
  token_exist: "The token already exists",
  collectibles: "Collectibles",
  assets: "Assets",
  add_customNFTs: "Add Custom NFTs",
  send: "Send",
  no_information: "No Information",
  pending: "Pending...",
  connect_currentWallet: "Please logout and connect to your current wallet",
  enter_nft_wallet: "Please enter the NFT wallet address",
  nft_transfer_success: "Sent successfully. Collectibles list may take up to 24 hours to sync.",
  no_permission: "Wallet in watch mode. You are not authorized to perform this transaction.",
  not_nft_owner: "This NFT has already been transferred. Collectibles list will update as soon as the sync is complete.",
  nft_update_notice: "NFT Update Notice",
  nft_update_notice_info: "Collectibles list may take up to 24 hours to refresh due to data synchronization from new transactions and NFT additions. <br><br>If you continue to experience issues, please email us at <a class='text-blue' href='mailto:hello@mathwallet.org'>hello@mathwallet.org</a>, and we will get back to you as soon as possible.",
  invalid_address_on_blockchain: "Invalid address on this blockchain. Please check.",
  not_support_current_chain: "This function does not support in current blockchain yet.",
};
